import { render, staticRenderFns } from "./stuclazz-view.vue?vue&type=template&id=0728a7c9&"
import script from "./stuclazz-view.vue?vue&type=script&lang=js&"
export * from "./stuclazz-view.vue?vue&type=script&lang=js&"
import style0 from "./stuclazz-view.vue?vue&type=style&index=0&id=0728a7c9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports